import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddAppointmentLayer from "../components/AddAppointmentLayer";


const AddAppointmentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Job" />

        {/* AddUserLayer */}
        <AddAppointmentLayer />


      </MasterLayout>
    </>
  );
};

export default AddAppointmentPage;
